module.exports = __webpack_public_path__ + "img/43.a6a6a491.png";